import * as React from 'react';
import { createLocators } from '@u1/locators';
import clsx from 'clsx';

import useStyles from './Skeleton.styles';

export interface ISkeletonProps {
  active?: boolean;
  block?: boolean;
  round?: boolean;
  children: React.ReactNode;
}

export const skeletonLocators = createLocators({
  name: 'Skeleton',
  componentLocators: ['root', 'animation'],
});
const { locators } = skeletonLocators();

const Skeleton: React.FC<ISkeletonProps> = ({
  block,
  round,
  active,
  children,
}) => {
  const classes = useStyles();

  return active ? (
    <div
      {...locators.root({ round: round })}
      className={clsx(classes.root, { [classes.round]: round })}
    >
      <span
        {...locators.animation({ block: block })}
        className={clsx({ [classes.block]: block })}
      >
        {children}
      </span>
    </div>
  ) : (
    <>{children}</>
  );
};

export default Skeleton;
